import { render, staticRenderFns } from "./CCalendarServicePanel.vue?vue&type=template&id=16995c1f&scoped=true"
import script from "./CCalendarServicePanel.vue?vue&type=script&lang=ts"
export * from "./CCalendarServicePanel.vue?vue&type=script&lang=ts"
import style0 from "./CCalendarServicePanel.vue?vue&type=style&index=0&id=16995c1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16995c1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VIcon,VImg})
